import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import {
  createRecordType,
  deleteRecordTypeById,
  getAllRecordTypes,
  getRecordTypeById,
  updateRecordTypeById,
} from './recordTypesApi';

export const useCreateRecordType = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['create_recordType'],
    mutationFn: createRecordType,
    onSuccess: () => {
      toast.success('Record type created successfully');
      queryClient.invalidateQueries(['recordTypes']);
    },
    onError: (error) => {
      console.log(error.response.data.message);
      toast.error(error.response.data.message);
    },
  });
};

export const useGetAllRecordTypes = () => {
  return useQuery({
    queryKey: ['recordTypes'],
    queryFn: getAllRecordTypes,
    onError: (error) => {
      console.error('Failed to fetch record types:', error);
      toast.error(
        'Failed to fetch record types: ' + (error.message || 'Unknown error')
      );
    },
  });
};

export const useGetRecordTypeById = (recordId) => {
  return useQuery({
    queryKey: ['recordTypes', recordId],
    queryFn: () => getRecordTypeById(recordId),
    onError: (error) => {
      console.error('Failed to fetch record type:', error);
      toast.error(
        'Failed to fetch record type: ' + (error.message || 'Unknown error')
      );
    },
  });
};

export const useUpdateRecordTypebyId = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateRecordTypeById,
    mutationKey: ['updateRecordTypebyId'],
    onSuccess: () => {
      toast.success('Successfully updated record type');
      queryClient.invalidateQueries(['recordTypes']);
    },
    onError: (err) => {
      console.log(err);
      toast.error(
        'Failed to update record type: ' + (err.message || 'Unknown error')
      );
    },
  });
};

export const useDeleteRecordTypebyId = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteRecordTypeById,
    mutationKey: ['deleteRecordTypebyId'],
    onSuccess: () => {
      toast.success('Successfully deleted record type');
      queryClient.invalidateQueries(['recordTypes']);
    },
    onError: (err) => {
      console.log(err);
      toast.error(
        'Failed to delete record type: ' + (err.message || 'Unknown error')
      );
    },
  });
};
